import React from 'react';
import Shimmer from '../Shimmer/Shimmer';

//Styles
import * as S from './infoModal.styles';

interface InfoModalLoaderProps {
  children: React.ReactNode;
  title?: string;
  isFullScreen?: boolean;
  customContentWrapperStyles?: React.CSSProperties;
  customClose: () => void;
}

const InfoModalLoader = ({
  children,
  title = 'Room Details',
  customContentWrapperStyles = {},
  isFullScreen,
  customClose,
}: InfoModalLoaderProps) => {
  return (
    <S.ModalBodyWrapper style={customContentWrapperStyles}>
      <S.ModalHeader>
        <p className="headerTag">{title}</p>
        <p className="headerText">
          <Shimmer
            width={'22rem'}
            height={'2rem'}
            radius={'0.2rem'}
            shimmerColor={
              'linear-gradient(to right, #E1E7EE 0%, #E1E7EE 20%, #E1E7EE 40%, #E1E7EE 100%)'
            }
            marginRight="0.4rem"
            customStyle={{
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          />
        </p>
        <a className="close" onClick={customClose}></a>
      </S.ModalHeader>
      <S.ModalContentWrapper $isFullScreen={isFullScreen}>{children}</S.ModalContentWrapper>
    </S.ModalBodyWrapper>
  );
};
export default InfoModalLoader;
